import React from "react";
import "./styles.css";
import {
  isAbsolute,
  isBrowser,
  getBaseUrl,
  decodeUrl,
  encodeUrl,
  getUrlParameters,
  getPathname,
  pathnameToObject,
  getWindowPathname,
  getWindowHost,
  getWindowHostName,
  getWindowHash,
  getWindowHref,
  getWindowPort,
  getWindowProtocol,
  getWindowSearch,
  joinUrl
} from "urley";

export default function App() {
  return (
    <main className="App">
      <header className="d-block d-md-flex">
        <article className="text-center container">
          <img
            src="https://i.ibb.co/kcpWdj0/EY.png"
            alt="urley"
            className="d-block m-auto"
          />
          <h1 className="mt-5">
            A cross-platform utility library to work <br />
            with <b>URLs</b>
          </h1>
          <h4 className="d-flex justify-content-center mt-5">
            <pre className="col-md-5 col-10">
              <code>npm install urley --save</code>
            </pre>
          </h4>
          <p className="mt-5 contact-screen">
            <a
              rel="noreferrer noopener"
              target="_blank"
              href="https://github.com/adenekan41/urley"
            >
              Github
            </a>
            <a
              rel="noreferrer noopener"
              target="_blank"
              href="https://npm.im/urley"
            >
              NPM
            </a>
            <a
              rel="noreferrer noopener"
              target="_blank"
              href="https://yarnpkg.com/package/urley"
            >
              Yarn
            </a>
            <a
              rel="noreferrer noopener"
              target="_blank"
              href="https://codewonders.dev"
            >
              By Codewonders
            </a>
          </p>
        </article>
      </header>
      <section className="container">
        <div className="row justify-content-center">
          <div className="col-md-9">
            <h3 className="text-center">Documentation For Urley</h3>
            <p className="text-center text-lead">
              A cross-platform library with a collection of handy utilites to
              work with URLs
            </p>
            <p className="text-center">
              <a
                href="https://codesandbox.io/s/red-tdd-q45p3?file=/src/App.js"
                className="btn btn-outline-dark mt-3 mb-5"
              >
                Open Demo In CodeSandbox
              </a>
            </p>

            <br />
            <br />
            <div className="utils__card mb-5">
              <h4>Is Absolute</h4>
              <hr />
              <p>
                Returns <code>Boolean</code> if the given string is an absolute
                URL.{" "}
                <a
                  rel="noreferrer noopener"
                  target="_blank"
                  href="https://seoclarity.net/resources/knowledgebase/difference-relative-absolute-url-15325/"
                >
                  https://seoclarity.net/resources/knowledgebase/difference-relative-absolute-url-15325/
                </a>
              </p>
              <pre>{'isAbsolute("https://google.com")'}</pre>
              <pre>
                {"// Returns =>"}{" "}
                {isAbsolute("https://google.com") ? "true" : "false"}
              </pre>
            </div>

            <div className="utils__card mb-5">
              <h4>Is Browser</h4>
              <hr />
              <p>Determines if the current runtime environment is a browser</p>
              <pre>{"isBrowser()"}</pre>
              <pre>
                {"// Returns =>"} {isBrowser() ? "true" : "false"}
              </pre>
            </div>

            <div className="utils__card mb-5">
              <h4>Get Base URL</h4>
              <hr />
              <p>Returns the current URL without any parameters</p>
              <pre>{"getBaseUrl('https://google.com/search?query=what')"}</pre>
              <pre>
                {"// Returns =>"}{" "}
                {getBaseUrl("https://google.com/search?query=what")}
              </pre>
            </div>

            <div className="utils__card mb-5">
              <h4>Decode URL</h4>
              <hr />
              <p>
                Function decodes a Uniform Resource Identifier (URI) component
                previously created by decodeURIComponent or by a similar routine
              </p>
              <pre>{'decodeUrl("https://google.com/?q=hwewer+erer+re")'}</pre>
              <pre>
                {"// Returns =>"}{" "}
                {decodeUrl("https://google.com/?q=hwewer+erer+re")}
              </pre>
            </div>

            <div className="utils__card mb-5">
              <h4>Encode URL</h4>
              <hr />
              <p>
                Function encodes a Uniform Resource Identifier (URI) component
                previously created by decodeURIComponent or by a similar routine
              </p>
              <pre>{'decodeUrl("https://google.com/?q=hwewer+erer+re")'}</pre>
              <pre>
                {"// Returns =>"}{" "}
                {"https://google.com/" + encodeUrl("?q=hwewer+erer+re")}
              </pre>
            </div>

            <div className="utils__card mb-5">
              <h4>Get URL Parameters</h4>
              <hr />
              <p>
                Returns an <code>object</code> containing the parameters of the
                URL
              </p>
              <pre>
                {
                  'getUrlParameters("https://ready.com/green?read=tour&green=tea")'
                }
              </pre>
              <pre>
                {"// Returns =>"}{" "}
                {JSON.stringify(
                  getUrlParameters(
                    "https://ready.com/green?read=tour&green=tea"
                  )
                )}
              </pre>
            </div>
            <div className="utils__card mb-5">
              <h4>Get Pathname To Object</h4>
              <hr />
              <p>
                Returns an <code>object</code> containing the pathname of the
                URL
              </p>
              <pre>{'getUrlParameters("https://ready.com/green/yellow")'}</pre>
              <pre>
                {"// Returns =>"}{" "}
                {JSON.stringify(
                  pathnameToObject("https://ready.com/green/yellow")
                )}
              </pre>
            </div>
            <div className="utils__card mb-5">
              <h4>Get Path Name</h4>
              <hr />
              <p>
                Returns pathname with a <code>regex</code> exec function see
                file
              </p>
              <pre>{'getPathname("https://ready.com/green/yellow")'}</pre>
              <pre>
                {"// Returns =>"}{" "}
                {JSON.stringify(getPathname("https://ready.com/green/yellow"))}
              </pre>
            </div>
            <div className="utils__card mb-5">
              <h4>Join URL</h4>
              <hr />
              <p>
                Join all given <code>URL</code> segments together, then
                normalizes the resulting URL
              </p>
              <pre>
                {
                  "joinUrl('https://ready.com/green/yellow', 'a', '/r/t', '?foo=barr')"
                }
              </pre>
              <pre>
                {"// Returns =>"}{" "}
                {JSON.stringify(
                  joinUrl(
                    "https://ready.com/green/yellow",
                    "a",
                    "/r/t",
                    "?foo=barr"
                  )
                )}
              </pre>
            </div>
            <div className="utils__card mb-5">
              <h4>Window Portion</h4>
              <hr />
              <h5 className="my-4">Get Window Path Name</h5>
              <p>
                Return pathname if parameter is passed or uses the one in the
                current <code>window</code> environment.
              </p>
              <pre>
                {
                  "getWindowPathname() \ngetWindowPathname('http://google.com/red/green/yellow')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowPathname())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(
                  getWindowPathname("http://google.com/red/green/yellow")
                )}
              </pre>
              <h5 className="my-4">Get Window Host</h5>
              <p>
                Return host if parameter is passed or uses the one in the
                current <code>window</code> environment.
              </p>
              <pre>
                {
                  "getWindowHost() \ngetWindowHost('http://google.com/red/green/yellow')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowHost())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(
                  getWindowHost("http://google.com/red/green/yellow")
                )}
              </pre>
              <h5 className="my-4">Get Window Host Name</h5>
              <p>
                Return hostname if parameter is passed or uses the one in the
                current <code>window</code> environment.
              </p>
              <pre>
                {
                  "getWindowHostName() \ngetWindowHostName('http://google.com/red/green/yellow')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowHostName())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(
                  getWindowHostName("http://google.com/red/green/yellow")
                )}
              </pre>
              <h5 className="my-4">Get Window Hash</h5>
              <p>
                Return hash if parameter is passed or uses the one in the
                current <code>window</code> environment.
              </p>
              <pre>
                {
                  "getWindowHash() \ngetWindowHash('http://google.com/red/green/yellow#read')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowHash())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(
                  getWindowHash("http://google.com/red/green/yellow#read")
                )}
              </pre>
              <h5 className="my-4">Get Window HREF (Hypertext REFerence)</h5>
              <p>
                Return href if parameter is passed or uses the one in the
                current
                <code> window</code> environment.
              </p>
              <pre>
                {
                  "getWindowHref() \ngetWindowHref('http://google.com/red/green/yellow#read')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowHref())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(
                  getWindowHref("http://google.com/red/green/yellow#read")
                )}
              </pre>
              <h5 className="my-4">Get Window Port</h5>
              <p>
                Return port if parameter is passed or uses the one in the
                current
                <code> window</code> environment.
              </p>
              <pre>
                {
                  "getWindowPort() \ngetWindowPort('http://google.com/red/green/yellow#read')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowPort())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(getWindowPort("http://google.com:3000"))}
              </pre>
              <h5 className="my-4">Get Window Protocol</h5>
              <p>
                Return protocol if parameter is passed or uses the one in the
                current
                <code> window</code> environment.
              </p>
              <pre>
                {
                  "getWindowProtocol() \ngetWindowProtocol('http://google.com/red/green/yellow#read')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowProtocol())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(getWindowProtocol("http://google.com:3000"))}
              </pre>
              <h5 className="my-4">Get Window Search</h5>
              <p>
                Return search strings if parameter is passed or uses the one in
                the current
                <code> window</code> environment.
              </p>
              <pre>
                {
                  "getWindowSearch() \ngetWindowSearch('http://google.com/red/green/yellow#read')"
                }
              </pre>
              <pre>
                {"// Returns => "}
                {JSON.stringify(getWindowSearch())} {"\n"}
                {"// Returns => "}
                {JSON.stringify(getWindowSearch("http://google.com/red?rerer"))}
              </pre>
            </div>
            <br />
          </div>
        </div>
      </section>
      <footer className="container text-center py-4">
        <hr />
        <p>
          Made with ❤ by{" "}
          <a
            rel="noreferrer noopener"
            target="_blank"
            href="https://codewonders.dev"
          >
            Adenekan Wonderful
          </a>
        </p>
      </footer>
    </main>
  );
}
